import { render } from "./DjosFeedback.vue?vue&type=template&id=d22361b8&scoped=true"
import script from "./DjosFeedback.vue?vue&type=script&lang=js"
export * from "./DjosFeedback.vue?vue&type=script&lang=js"

import "./DjosFeedback.vue?vue&type=style&index=0&id=d22361b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22361b8"]])

export default __exports__